<template>
  <div>
    <table-manager @filterChanged="filterChanged" @paginationChanged="paginationChanged" :options="options" @ClickOnAddButton="showAdd"/>

    <basic-table
      v-if="radiusAccounts"
      :items="radiusAccounts"
      :fields="radiusAccountsFields"
      @ClickOnDeleteButton="ClickOnDeleteButton"
      @ClickOnEditButton="editItem"
      :filter="filter"
      :perPage="perPage"
      :currentPage="currentPage"
      v-model="totalRows"
      isDelete="true"
      isEdit="true"/>
    <table-manager-bottom
      :totalRows="totalRows" :perPage="perPage"
      v-model="currentPage"/>
    <editModal :editItem="selectedRadiusAccounts"/>
  </div>
</template>

<script>
import editModal from './editModal'

export default {
  components: {
    editModal
  },
  data () {
    return {
      radiusAccountsFields: [
        {key: 'id', label: 'ID', sortable: true},
        {key: 'name', label: this.$i18n.t('Full name'), sortable: true},
        {key: 'actions', label: this.$i18n.t('Actions'), sortable: true}
      ],
      options: {
        isShowAddButton: true
      },
      selectedRadiusAccounts: null,
      filter: null,
      perPage: 20,
      totalRows: 0,
      currentPage: 1
    }
  },
  methods: {
    showAdd () {
      this.selectedRadiusAccounts = {
        add_nas_attributes: false,
        id: 0,
        name: '',
        password: ''

      }
      this.$root.$emit('bv::show::modal', 'modalEditRadiusAccountsSetting', '#btnShow')
    },
    editItem (item) {
      this.selectedRadiusAccounts = JSON.parse(JSON.stringify(item))
      this.$root.$emit('bv::show::modal', 'modalEditRadiusAccountsSetting', '#btnShow')
    },
    ClickOnDeleteButton (item) {
      this.$root.$emit('showConfirmation', 'Confirmation', this.$i18n.t('Are you sure you want to delete one of "RADIUS account"?'), this.deleteItem, item)
    },
    deleteItem (item) {
      let response = this.$store.dispatch('Settings/DELETE_RADIUS_ACCOUNTS', item.id)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_RADIUS_ACCOUNTS')
          this.$root.$emit('makeToasts')
        }
      })
    },
    filterChanged (value) {
      this.filter = value
    },
    paginationChanged (value) {
      this.perPage = value
    }
  },
  computed: {
    radiusAccounts () {
      return this.$store.getters['Settings/RADIUS_ACCOUNTS']
    }
  },
  mounted () {
    this.$store.dispatch('Settings/GET_RADIUS_ACCOUNTS')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/settings/system/radiusAccounts/main.vue